const AnalyticsConstants = {
  COURSE_VIEWED: "Course Viewed",
  PASSWORD_RESET: "Password Reset",
  FULL_NAME_CHANGED: "Full Name Changed",
  PHONE_NUMBER_CHANGED: "Phone Number Changed",
  LEARNER_LOGIN_SUCCESS: "Learner Login Success",
  ENROLL_BUTTON_CLICKED: "Enroll Button Clicked",
  MORE_SCHEDULES_VIEWED: "More Schedules Viewed",
  LEARNER_LOGOUT_SUCCESS: "Learner Logout Success",
  VULCAN_WEBSITE_LOADED: "Vulcan Website Loaded...",
  EDUCATOR_LOGIN_SUCCESS: "Educator Login Success",
  EDUCATOR_LOGOUT_SUCCESS: "Educator Logout Success",
  PASSWORD_CHANGED: "Password Changed Using Dashboard",
  EDUCATOR_PROFILE_UPDATED: "Educator Profile Updated",
  EDUCATOR_REGISTRATION_SUCCESS: "Educator Registration Success",
  LEARNER_REGISTRATION_SUCCESS: "Learner Registration Success",
};
Object.freeze(AnalyticsConstants);
export default AnalyticsConstants;
